// extracted by mini-css-extract-plugin
export var active = "_j0-2";
export var recordingDot = "_j0-1";
export var recordingIndicator = "_j0-0";